import React, { Component } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import { graphql, QueryRenderer } from 'react-relay';
import environment from '../../environment';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Typography, Grid, CircularProgress, Button } from '@material-ui/core';

import { useStyles } from './styles.js';
import ChapterStatus from '../ChapterStatus/ChapterStatus';

class ChapterView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  onChapterClick(index, chapter) {
    this.setState({
      current_chapter: index + 1,
      chapter_name: chapter.chapter_name,
    });
    this.props.setChapter(index + 1, chapter);
  }

  render() {
    const { classes } = this.props;

    return (
      <div style={{ display: 'flex', justifyContent: 'inherit' }}>
        {this.props.game_settings.map((chapter, index) => {
          return (
            <li
              key={`Chapter${index}`}
              className={clsx(classes.chapterHolder, this.props.liStyle)}
              style={
                //Currently this chapter is getting called from WMDashboard & Pickem game
                //current_chapter is only set by Pickem because we need to highlight current chapter

                //Highlight current chpater if current chapter is set in props
                index + 1 == this.props.current_chapter
                  ? {
                      ...this.props.chapterHighlightStyle,
                    }
                  : //Chapter is not active and restrict chapter prop is set then appply not allowed cursor
                  !chapter.active && this.props.restrictChapter
                  ? {
                      ...this.props.borderStyle,
                      cursor: 'not-allowed',
                    }
                  : {
                      ...this.props.borderStyle,
                      cursor: 'pointer',
                    }
              }
              onClick={
                //onClick is registered only on active chapters
                (chapter.active && this.props.restrictChapter) ||
                !this.props.restrictChapter
                  ? this.onChapterClick.bind(this, index, chapter)
                  : null
              }
            >
              {/**Chpater name color changes on the basis of props */}
              <Typography key={`ChapterName${index}`} style={index + 1 == this.props.current_chapter ? {...this.props.style, color: '#fff'} : this.props.style}>
                {chapter.chapter_name}
              </Typography>

              {/**If show no date prop is set to true then return empty string otherwise display
               * chapter start and end date */}
              {this.props.noDate ? (
                ''
              ) : (
                <Typography
                  key={`ChapterDate${index}`}
                  className={classes.chapterDate}
                >
                  {moment(chapter.chapter_start_date).format('MMM Do YY')} -
                  {moment(chapter.chapter_end_date).format('MMM Do YY')}
                </Typography>
              )}

              {/**guest_answer_count contains question count and answered questions
               * for all the chapters */}
              {this.props.noShowSubmission ? (
                ' '
              ) : (
                <ChapterStatus
                  active={chapter.active}
                  variables={{
                    args: {
                      ...this.props.variables.arguments,
                      quarter_id: index + 1,
                    },
                  }}
                />
              )}
            </li>
          );
        })}
      </div>
    );
  }
}

ChapterView.propTypes = {
  className: PropTypes.string,
};

export default withStyles(useStyles)(ChapterView);
